import request from "@/utils/request.js"
// 临床案例 - 推荐四个
export function get_tj_list(data) {
    return request({
        method: 'GET',
        url: '/aohua.clinicalcases/get_tj_list',
        params: data
    })
}
// 临床案例 - 分类
export function get_category(data) {
    return request({
        method: 'GET',
        url: '/aohua.clinicalcases/get_category',
        params: data
    })
}

// 临床案例 - 案例列表
export function get_list(data) {
    return request({
        method: 'GET',
        url: '/aohua.clinicalcases/get_list',
        params: data
    })
}
